import { asyncTypes } from 'helpers/actionTypes'
import { API, APP_NAME } from 'constants/index'
import { apiService, firebaseService } from 'services'

const { getAuth, getFirebaseToken } = firebaseService

export const FIREBASE_LOGIN = asyncTypes('FirebaseState/FIREBASE_LOGIN')

const REGISTER_FIREBASE_TOKEN = asyncTypes('FirebaseState/REGISTER_FIREBASE_TOKEN')

const LOGIN_FIREBASE_TOKEN = asyncTypes('FirebaseState/LOGIN_FIREBASE_TOKEN')

export function loginFirebase(token) {
  return async (dispatch) => {
    try {
      if (!token) return
      dispatch({ type: LOGIN_FIREBASE_TOKEN.REQUEST, token })
      const fbAuth = await getAuth()
      await fbAuth.signInWithCustomToken(token)
      dispatch({ type: LOGIN_FIREBASE_TOKEN.SUCCESS })
      return true
    } catch (error) {
      dispatch({ type: LOGIN_FIREBASE_TOKEN.FAILURE, error })
    }
  }
}

export function registerFirebaseToken() {
  return async (dispatch) => {
    const token = await getFirebaseToken()
    if (!token) return
    const postData = {
      device_token: token,
      app_id: APP_NAME.TEACHER,
    }
    dispatch({ type: REGISTER_FIREBASE_TOKEN.REQUEST, postData })
    apiService.post(API.REGISTER_FIREBASE_TOKEN_API, postData).then(
      (response) => {
        if (!response.success) {
          return dispatch({ type: REGISTER_FIREBASE_TOKEN.FAILURE, error: response.data })
        }
        return dispatch({ type: REGISTER_FIREBASE_TOKEN.SUCCESS, data: response.data })
      },
      (error) => {
        dispatch({ type: REGISTER_FIREBASE_TOKEN.FAILURE, error })
      }
    )
  }
}

const initialState = {
  isConnectFirebase: false,
}

const ACTION_HANDLERS = {
  [LOGIN_FIREBASE_TOKEN.SUCCESS]: (state) => ({
    ...state,
    isConnectFirebase: true,
  }),
  [LOGIN_FIREBASE_TOKEN.FAILURE]: (state) => ({
    ...state,
    isConnectFirebase: false,
  }),
}

export default function FirebaseReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}
